import type { PaymentConfig } from '../../types/sales.types';

type MethodOption = { id: string; name: string };

/**
 * Etiqueta para UI del método de pago: usa globalPaymentMethod si existe;
 * si no, deriva de paymentConfig.payments (paso 2 no siempre rellenaba global).
 */
export function getPaymentMethodsDisplayLabel(
  paymentConfig: PaymentConfig,
  paymentMethodOptions: MethodOption[],
): string {
  if (!paymentConfig.useGlobalPayment) {
    return 'Métodos individuales por pieza';
  }

  if (paymentConfig.globalPaymentMethod) {
    const fromGlobal = paymentMethodOptions.find((m) => m.id === paymentConfig.globalPaymentMethod);
    if (fromGlobal?.name) return fromGlobal.name;
  }

  const payments = paymentConfig.payments ?? [];
  if (payments.length === 0) {
    return paymentConfig.globalPaymentMethod ?? 'No seleccionado';
  }

  const labels = [
    ...new Set(
      payments.map((p) => {
        const opt = paymentMethodOptions.find((m) => m.id === p.method);
        return opt?.name ?? p.method;
      }),
    ),
  ];

  if (labels.length === 1) {
    return labels[0];
  }
  return labels.join(' · ');
}
